import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { uploadDocumentAPIHelper, getUserDocumentsAPIHelper, deleteAllDocumentsAPIHelper, deleteDocumentAPIHelper } from "../helpers/documentAPI.ts";
import { DocumentState } from "../../Components/Dashboard/Documents/types/document.types";

const initialState: DocumentState = {
    documents: [],
    loading: false,
    error: null,
};

// ================= DOCUMENT THUNKS =================

export const getUserDocuments = createAsyncThunk(
    "/document/getUserDocuments",
    async (userId: string | number, thunkAPI) => {
        try {
            return await getUserDocumentsAPIHelper(userId);
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const uploadDocument = createAsyncThunk(
    "/document/uploadDocument",
    async (payload: { formData: FormData, userId: string | number }, thunkAPI) => {
        try {
            const response = await uploadDocumentAPIHelper(payload.formData);
            // Re-fetch documents automatically after successful upload
            thunkAPI.dispatch(getUserDocuments(payload.userId));
            return response;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const deleteDocument = createAsyncThunk(
    'document/deleteDocument',
    async ({ userId, docId }: { userId: number, docId: string | number }) => {
        await deleteDocumentAPIHelper(userId, docId);
        return docId; // Return the deleted ID so we can remove it from state
    }
);

export const deleteAllDocuments = createAsyncThunk(
    'document/deleteAllDocuments',
    async (userId: number) => {
        await deleteAllDocumentsAPIHelper(userId);
        return []; // Return empty array to clear state
    }
);
const documentSlice = createSlice({
    name: "document",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getUserDocuments.fulfilled, (state, action) => {
                console.log("getUserDocuments.fulfilled", action.payload);
                state.documents = action.payload.data;
            })
            .addCase(uploadDocument.fulfilled, (state, action) => {
                console.log("uploadDocument.fulfilled", action.payload);
            })
            .addCase(deleteDocument.fulfilled, (state, action) => {
                // Remove the specific document from the list
              
                state.documents = state.documents?.filter(doc => doc.id !== action.payload) || [];
            })

            .addCase(deleteAllDocuments.fulfilled, (state) => {
                // Clear all documents from the list
                state.documents = [];
            })

            /* ================= GLOBAL MATCHERS ================= */
            .addMatcher(
                (action) => action.type.endsWith("/pending"),
                (state, action) => {
                    console.log(action.type);
                    state.loading = true;
                    state.error = null;
                }
            )
            .addMatcher(
                (action) => action.type.endsWith("/rejected"),
                (state, action: any) => {
                    console.log(action.type, action.payload);
                    state.loading = false;
                    state.error = action.payload || "Something went wrong";
                }
            )
            .addMatcher(
                (action) => action.type.endsWith("/fulfilled"),
                (state) => {
                    state.loading = false;
                }
            );

    }
});

export default documentSlice.reducer;